import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import config from '../settings/config';

const useStateBackend = () => {
    const [isBackendUp, setIsBackendUp] = useState(() => {
        const storedState = localStorage.getItem("backendState") === "true";
        return storedState;
    });
    const [isChecking, setIsChecking] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();


    useEffect(() => {
        let isMounted = true;

        const pingBackend = async () => {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => {
                controller.abort();
            }, 1500);

            try {
                const response = await fetch(`${config.app.host}/api/v1/ping`, {
                    method: "GET",
                    headers: { "Content-Type": "application/json" },
                    signal: controller.signal
                });
                
        
                clearTimeout(timeoutId);
                
                if (response.ok) {
                    localStorage.setItem("backendState", "true");
                    setIsBackendUp(true);
                    if (location.pathname === "/waiting") {
                        navigate("/"); 
                    }
                } else {
                    throw new Error(`Backend responded with status: ${response.status}`);
                }
            } catch (error) {
                clearTimeout(timeoutId);
                // Бэкенд недоступен
                localStorage.setItem("backendState", "false");
                setIsBackendUp(false);
                
                // Добавляем проверку на навигацию, чтобы избежать бесконечного цикла навигаций
                if (location.pathname !== "/waiting") {
                    navigate("/waiting", { replace: true }); // replace: true чтобы избежать истории навигаций
                } else {
                }
            } finally {
                if (isMounted) {
                    setIsChecking(false);
                }
            }
        };

        if (!localStorage.getItem("backendState")) {
            localStorage.setItem("backendState", "true");
        }

        pingBackend();
        
        const interval = setInterval(pingBackend, 2500);
        
        return () => {
            isMounted = false;
            clearInterval(interval);
        };
    }, [isBackendUp, navigate, location]);
    return { isBackendUp, isChecking };
};

export default useStateBackend;